export default __webpack_public_path__ + "static/media/Cookies_Policy.bc5a849c.pdf";